import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography  } from '@mui/material';

const UsersPerActivityTable = ({ data }) => {
  return (
    <Paper style={{ maxHeight: '400px', overflowY: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        <FormattedMessage id='moderatorUserTracking.perActivity.label.title' defaultMessage='Users attendance' />
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><FormattedMessage id='moderatorUserTracking.perActivity.table.name' defaultMessage='Name' /></TableCell>
            <TableCell><FormattedMessage id='moderatorUserTracking.perActivity.table.count' defaultMessage='Training Count' /></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.name}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.trainingCount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

UsersPerActivityTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      trainingCount: PropTypes.number,
    })
  ),
};

export { UsersPerActivityTable };